const enum DateFilterConstantsEnum {
  MONTHLY = 'monthly',
  DAILY = 'daily',
  FLEXIBLE = 'flexible',
  YEAR = 'year',
  MONTH = 'month',
  DAY = 'day',
  FORMAT = 'MM-DD-YYYY HH:mm:ss',
}

export { DateFilterConstantsEnum };
